import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AllSubItem } from '../../interfaces/allSubTable.interface';
import { BackendAccessService } from '../../Services/APICalls/backend-access-service';
import { AuthService } from '../../Services/Auth/auth.service';
import { LoadingService } from '../../Services/Loading/loading-service.service';
import { SubProductsService } from '../../Services/sub-products.service';

@Component({
  selector: 'app-all-subs-page',
  templateUrl: './all-subs-page.component.html',
  styleUrls: ['./all-subs-page.component.scss'],
  standalone: false,
})

/* istanbul ignore next */
export class AllSubsPageComponent {
  displayedColumns: string[] = [
    'status',
    'maxioSubscriptionId',
    'propertyName',
    'product',
    'expiryDate',
    // 'actions',
  ];
  dataSource = new MatTableDataSource<AllSubItem>([]);
  pageNo: number = 0; // Default page number
  itemsPerPage: number = 5; // Default items per page
  totalRecords: number = 0;

  constructor(
    readonly backend: BackendAccessService,
    readonly auth: AuthService,
    readonly loading: LoadingService,
    private readonly subProducts: SubProductsService
  ) {}
  /* istanbul ignore next */
  ngOnInit(): void {
    this.fetchSubscriptions();
  }

  /* istanbul ignore next */
  isOneTimeSubscription(row: AllSubItem): boolean {
    return this.subProducts.isOneTimeProductId(row.productId);
  }

  /* istanbul ignore next */
  fetchSubscriptions(): void {
    this.loading.show();
    this.auth.getAllRoles().subscribe((roles: string[]) => {
      let roleId = 'ZentraIntegrator'; // default fallback

      if (roles.includes('GuestPurchaser')) {
        roleId = 'GuestPurchaser';
      } else if (roles.includes('ZentraEndUser')) {
        roleId = 'ZentraEndUser';
      }

      this.backend
        .getAllSubsListPage(roleId, this.pageNo, this.itemsPerPage)
        .subscribe({
          next: (response: any) => {
            this.dataSource.data = response.subscriptions;
            this.totalRecords = response.totalRecords;
            this.loading.hide();
          },
          error: (error) => {
            console.error('Error fetching subscription data:', error);
            this.loading.hide();
          },
        });
    });
  }

  /**
   * Apply column-specific filtering to the table.
   */
  /* istanbul ignore next */
  applyInputFilter(event: Event, column: string): void {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();

    this.dataSource.filterPredicate = (data: AllSubItem, filter: string) => {
      const columnValue = (data as any)[column]?.toString().toLowerCase() ?? '';
      return columnValue.includes(filter);
    };

    this.dataSource.filter = filterValue; // Apply the filter
  }

  /**
   * Handle pagination events.
   */
  /* istanbul ignore next */
  onPageChange(event: any): void {
    this.pageNo = event.pageIndex;
    this.itemsPerPage = event.pageSize;

    this.fetchSubscriptions();
  }
}
